import { createContext, useContext, useState } from "react";
import PropTypes from 'prop-types';

// This component is a provider that contains payment status in all APP components
const PaymentContext = createContext();

const PaymentProvider = ({ children }) => {
  const [payment, setPayment] = useState(false)
  const togglePayment = () => {
    setPayment(payment === false ? true : false)
  }
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerId, setCustomerId] = useState("");

  return (
    <PaymentContext.Provider value={{ payment, togglePayment, paymentAmount, setPaymentAmount, customerEmail, setCustomerEmail, customerId, setCustomerId }}>
      {children}
    </PaymentContext.Provider>
  )
}

PaymentProvider.propTypes = {
  children: PropTypes.node,
};

export const usePaymentContext = () => {
  const {
    payment,
    togglePayment,
    paymentAmount,
    setPaymentAmount,
    customerEmail,
    setCustomerEmail,
    customerId,
    setCustomerId
  } = useContext(PaymentContext);
  return {
    payment,
    togglePayment,
    paymentAmount,
    setPaymentAmount,
    customerEmail,
    setCustomerEmail,
    customerId,
    setCustomerId
  }
}

export default PaymentProvider;